
import type { CustomTheme } from '.'
// primary red: #cd2331
// primary blue: #0f2c58

export const customTheme: CustomTheme = {
  colors: {
    blue: {
      DEFAULT: '#0f2c58',
      '50': '#E9F0FB',
      '100': '#C2D6F5',
      '200': '#9BBCEE',
      '300': '#74A2E7',
      '400': '#4C87E1',
      '500': '#256DDA',
      '600': '#1E57AE',
      '700': '#164183',
      '800': '#0f2c58',
      '900': '#07162C'
    },
    //secondary: {
    //  DEFAULT: '#CD2331',
    //  "50": "#FBE9EB",
    //  "100": "#F5C2C6",
    //  "200": "#EE9BA2",
    //  "300": "#E7747D",
    //  "400": "#E14C59",
    //  "500": "#CD2331",
    //  "600": "#AE1E2A",
    //  "700": "#83161F",
    //  "800": "#570F15",
    //  "900": "#2C070A"
    //},
    // green: {
    //   DEFAULT: '#4BB44F',
    //   "50": "#EDF8ED",
    //   "100": "#CDEACE",
    //   "200": "#ACDDAE",
    //   "300": "#8CCF8E",
    //   "400": "#6BC26F",
    //   "500": "#4BB44F",
    //   "600": "#3C903F",
    //   "700": "#2D6C2F",
    //   "800": "#1E4820",
    //   "900": "#0F2410"
    // }
  },
  semanticTokens: {
    colors: {
      'dashboard-header-bg': 'blue.800',

      // // Wizzard header
      'wizzard-header-bg': 'blue.800',
      // 'wizzard-header-history-timeline-dot-bg': 'gray.300',
      // 'wizzard-header-history-timeline-line-bg': 'gray.700',
      // 'wizzard-header-history-timeline-label-color': 'gray.200',
      // 'wizzard-header-history-timeline-user-color': 'gray.200',
      // 'wizzard-header-history-timeline-description-color': 'gray.300',
      // 'wizzard-header-history-scrollbar-thumb-color': 'gray.800',
      // 'wizzard-header-history-scrollbar-track-color': 'gray.600',

      // Steps
      // 'steps-container-bg': 'blue.800',
      // 'step-bg': 'white',
      // 'step-current-bg': 'secondary.500',
      // 'step-number-border': 'gray.100',
      // 'step-number-bg': 'transparent',
      // 'step-number-color': 'gray.100',
      // 'step-number-passed-bg': 'none',
      // 'step-number-passed-color': 'white',
      // 'step-divider-bg': 'gray.600',
      // Steps progress
      // 'step-progress-passed-bg': 'secondary.500',

      // 'input-border': 'blue.700',
      // 'input-focused-border': 'blue.500',
      // 'select-border': 'blue.700',
      // 'checkbox-border': 'blue.700',

      // 'badge-bg': 'blue.800',

      'news-timeline-info-bg': 'gray.200',
      'news-timeline-info-fg': 'gray.600',
    },
  },
  components: {
    Switch: {
      defaultProps: {
        colorScheme: 'primary',
      }
    },
  }
}